export default class UserChargeInfo {
  price: number = 0
  remark: string = '测试充值'
  type: '1' | '2' = '1'
  userId: number = 0
}
